import { render, staticRenderFns } from "./report-common.vue?vue&type=template&id=065e033a&scoped=true&"
import script from "./report-common.vue?vue&type=script&lang=ts&"
export * from "./report-common.vue?vue&type=script&lang=ts&"
import style0 from "./report-common.vue?vue&type=style&index=0&id=065e033a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065e033a",
  null
  
)

export default component.exports